import styles from './Areas.module.scss'
import { useGetAreas } from '@/modules/Areas'
import { Area } from './components/Area'
import { useAreaStore } from '@/modules/Areas'
import { Loader } from '@/ui/Loader'

export const AreasView = () => {
    const { data: areas, isPending } = useGetAreas()
    const { selectedAreaCode } = useAreaStore()

    const filteredAreas =
        selectedAreaCode === 'all'
            ? areas
            : selectedAreaCode === 'night'
              ? areas?.map((area) => ({ ...area, workstations: area.workstations.filter((ws) => ws.isNightNetwork) }))
              : areas?.filter((area) => area.code === selectedAreaCode)

    if (isPending) {
        return <Loader />
    }

    return <div className={styles.areasView}>{filteredAreas?.map((area) => <Area key={area.code} area={area} />)}</div>
}
